import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { scrollToSection } from "@/lib/scrollToSection";

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="py-12 border-t border-border bg-card/50">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
                <span className="font-display text-primary-foreground font-bold text-sm">IH</span>
              </div>
              <span className="font-display text-xl font-bold text-foreground">
                Ice<span className="text-primary">Hub</span>
              </span>
            </div>
            <p className="text-muted-foreground text-sm">
              {t.footer.tagline}
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-foreground mb-4 uppercase text-sm">{t.footer.quickLinks}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/#hero" onClick={() => scrollToSection("hero")} className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.home}</Link></li>
              <li><Link to="/#standings" onClick={() => scrollToSection("standings")} className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.standings}</Link></li>
              <li><Link to="/#tournaments" onClick={() => scrollToSection("tournaments")} className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.teams}</Link></li>
              <li><Link to="/schedule" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.schedule}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-foreground mb-4 uppercase text-sm">{t.footer.resources}</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.api}</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.support}</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.contact}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-foreground mb-4 uppercase text-sm">{t.footer.company}</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.about}</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.careers}</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">{t.footer.press}</a></li>
              <li><Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © 2025 IceHub. {t.footer.copyright}
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors text-sm">
              Twitter
            </a>
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors text-sm">
              Instagram
            </a>
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors text-sm">
              YouTube
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
